import {
  Box,
  Button,
  InputAdornment,
  TextField,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { useState, useEffect } from 'react';
import { useTheme } from '@emotion/react';
import mailicon from 'assets/images/mailicon.png';
import React from 'react';
import SendOTP from './SendOTP';
import { poppins300, poppins400, poppins700 } from 'theme/common.style';
import { FORGOT_PASSWORD } from 'constant/app.config';
import { postApiCall } from 'api/apiService';
import Loading from 'assets/images/loading.png';

function ForgotPassword(props) {
  const {
    setShowsendOTP,
    showsendOTP,
    handleShowNewPassword,
    setShowForgotPassword,
    setotpResponseObj,
  } = props;
  const theme = useTheme();
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const [email, setEmail] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleEmailChange = (e) => {
    setEmail(e.target.value.trim());
    setErrorMessage(''); // Clear errors while typing
  };

  const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!email) return 'Please enter an email address.';
    if (!emailRegex.test(email)) return 'Please enter a correct email address.';
    return null;
  };

  const handleSubmit = async () => {
    const validationError = validateEmail(email);
    if (validationError) {
      setErrorMessage(validationError);
      return;
    }

    try {
      setIsLoading(true);
      const response = await postApiCall(FORGOT_PASSWORD, { email });
      if (response?.data?.status === 1) {
        setShowsendOTP(true); // Trigger OTP input UI
        setShowForgotPassword(true);
      } else {
        setErrorMessage(
          response?.data?.message || 'Failed to send OTP. Please try again.'
        );
      }
    } catch (error) {
      setErrorMessage('Network error. Please try again later.');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (isLoading) {
      document.body.style.pointerEvents = 'none';
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    };
  }, [isLoading]);

  return (
    <Box
      autoComplete="off"
      component="form"
      method="post"
      sx={{
        marginLeft: matchessm ? '0px' : matchesmd ? -28.5 : '',
        justifyContent: 'center',
      }}
    >
      {!showsendOTP ? (
        <>
          <Typography component="div" sx={loginMailDiv}>
            <Typography component="label" sx={loginLabelEmail}>
              Email Address
            </Typography>

            <Typography
              component="div"
              sx={{ paddingTop: '10px', paddingRight: '5%' }}
            >
              <TextField
                variant="outlined"
                size={matchessm ? 'small' : ''}
                tabIndex={1}
                sx={{
                  '.MuiFormHelperText-contained': { margin: '0' },
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderColor: 'rgba(0, 85, 255, 0.64)',
                      fontFamily: 'poppins !important',
                    },
                  },
                  '& .MuiFormHelperText-root': {
                    fontSize: matchessm ? '10px' : '13px',
                    fontWeight: 600,
                    fontFamily: 'Poppins',
                    color: errorMessage ? '#d42f2fff' : 'inherit',
                  },
                  width: !matchessm ? '424px' : '100%',
                  background: 'transparent',
                  borderRadius: '5px',
                  color: '#000000',
                }}
                placeholder="name@Example:.com.au"
                id="userEmail"
                type="email"
                name="userEmail"
                value={email}
                error={!!errorMessage}
                helperText={errorMessage}
                onChange={handleEmailChange}
                InputProps={{
                  style: {
                    fontSize: matchessm ? '12px' : matchesmd ? '14px' : '',
                    fontFamily: 'poppins',
                  },
                  startAdornment: (
                    <InputAdornment position="start">
                      <img
                        alt="img"
                        src={mailicon}
                        style={{
                          background: 'transparent',
                          paddingRight: '10px',
                          borderRight: '1px solid black',
                          width: matchesmd ? '25px' : '40px',
                          height: matchesmd ? '20px' : '',
                        }}
                      />
                    </InputAdornment>
                  ),
                }}
              />
            </Typography>
          </Typography>
          <Typography
            component="div"
            sx={{
              display: 'flex',
              justifyContent: matchesmd ? 'left' : 'left',
              paddingTop: '10px',
              paddingRight: '5%',
              width: '100%',
            }}
          >
            <Button
              onClick={handleSubmit}
              tabIndex={4}
              disabled={isLoading}
              sx={[
                loginButton,
                {
                  padding: matchessm ? '4px 30px' : '10px 50px',
                  textTransform: 'capitalize',
                  fontFamily: 'poppins !important',
                },
              ]}
              size="large"
            >
              {isLoading ? 'Sending...' : 'Send OTP'}
            </Button>
            {isLoading && (
              <img
                alt="Loader"
                src={Loading}
                className="loaderImage"
                style={{ height: '40px', width: '40px' }} // 🔹 smaller & aligned
              />
            )}
          </Typography>
        </>
      ) : (
        <SendOTP
          setotpResponseObj={setotpResponseObj}
          setShowForgotPassword={setShowForgotPassword}
          handleShowNewPassword={handleShowNewPassword}
          setShowsendOTP={setShowsendOTP}
          EmailId={email}
        />
      )}
    </Box>
  );
}

ForgotPassword.propTypes = {};

export default ForgotPassword;

export const loginLabelEmail = {
  ...poppins300,
  color: 'black !important',
  fontWeight: '500 !important',
  paddingBottom: '5px',
};

export const loginMailDiv = {
  paddingBottom: '2em',
};

export const loginButton = {
  // "border-image-slice": 2,
  ...poppins400,
  color: '#000000',
  border: '1px solid',
  background: 'transparent',
  borderImage: 'linear-gradient(to right,#5FACDF, #6668DB, #C6A7D5) 1',
};
